import { Component, OnInit } from "@angular/core";
import { SchoolselectorService } from "../../schoolselector/schoolselectorservice.service";
import { DataService_ScanStationRebuildSU } from "./shared/data.service";
import { IntListRequest } from "./shared/IntListRequest";
import { ConfirmationService } from "primeng/api";

@Component({
	selector: "app-scan-station-rebuild-su",
	templateUrl: "./scan-station-rebuild-su.component.html",
	styleUrls: ["./scan-station-rebuild-su.component.css"],
})
export class ScanStationRebuildSUComponent implements OnInit {
	constructor(
		private selectService: SchoolselectorService,
		private dataService: DataService_ScanStationRebuildSU,
		private confirmationService: ConfirmationService
	) {}

	ngOnInit(): void {
		this.subscription = this.selectService.onSchoolChanged().subscribe((school) => {
			this.onSchoolChange(school);
		});
	}

	ngOnDestroy() {
		this.subscription.unsubscribe();
	}

	///////////////////////////////////////////////////////////
	// Data
	///////////////////////////////////////////////////////////

	subscription: any;

	SelectedSchool: any;

	LoadingFacility: boolean = false;
	SelectedFacility: any;
	lstFacility: any = [];

	LoadingScanStation: boolean = false;
	SelectedScanStations: any = [];
	lstScanStation: any = [];

	//
	// Table
	//
	pagerows: any = 10;
	pagefirst: any = 0;

	//Filter lists
	lstFacilityFullName: any = [];
	lstIsScanStationDesc: any = [];
	lstIsMultiStationDesc: any = [];
	lstVersion: any = [];
	lstOS: any = [];
	lstAlreadyRebuildingDesc: any = [];

	//Cols
	cols: any = [
		//INSERT CUSTOM COLUMNS HERE
		{ field: "ScanStation", header: "Station" },
		{ field: "FacilityFullName", header: "Facility" },
		{ field: "IsScanStationDesc", header: "Running ScanStation" },
		{ field: "IsMultiStationDesc", header: "Running MultiStation" },
		{ field: "Version", header: "Version" },
		{ field: "OS", header: "OS" },
	];

	Processing: boolean = false;

	errorMessage: string = "";

	///////////////////////////////////////////////////////////

	///////////////////////////////////////////////////////////
	// Load Data
	///////////////////////////////////////////////////////////

	loadFacility() {
		if (this.SelectedSchool == undefined || this.SelectedSchool.SchoolID == undefined) {
			return;
		}

		this.LoadingFacility = true;
		var result = this.dataService.FacilitySelectList(this.SelectedSchool.SchoolID);
		result.subscribe(
			(response) => {
				this.LoadingFacility = false;

				this.lstFacility = response;

				if (this.SelectedSchool.SchoolID <= 0) {
					this.lstFacility.unshift({
						FacilityID: -1,
						FacilityName: "All",
						FacilityFullName: "All",
					});
				}

				this.onFacilityChange(this.lstFacility[0]);
			},
			(error) => {
				this.LoadingFacility = false;
			}
		);
	}

	loadScanStation() {
		this.errorMessage = "";
		this.SelectedScanStations = [];

		this.LoadingScanStation = true;
		var result = this.dataService.ScanStationRebuildSelectList(this.SelectedSchool.SchoolID, this.SelectedFacility.FacilityID);
		result.subscribe(
			(response) => {
				this.LoadingScanStation = false;

				this.lstScanStation = response;

				this.lstFacilityFullName = Array.from(new Set(this.lstScanStation.map((item: any) => item.FacilityFullName))).sort();
				this.lstIsScanStationDesc = Array.from(new Set(this.lstScanStation.map((item: any) => item.IsScanStationDesc))).sort();
				this.lstIsMultiStationDesc = Array.from(new Set(this.lstScanStation.map((item: any) => item.IsMultiStationDesc))).sort();
				this.lstVersion = Array.from(new Set(this.lstScanStation.map((item: any) => item.Version))).sort();
				this.lstOS = Array.from(new Set(this.lstScanStation.map((item: any) => item.OS))).sort();
				this.lstAlreadyRebuildingDesc = Array.from(new Set(this.lstScanStation.map((item: any) => item.AlreadyRebuildingDesc))).sort();
			},
			(error) => {
				this.LoadingScanStation = false;
			}
		);
	}

	///////////////////////////////////////////////////////////

	///////////////////////////////////////////////////////////
	// Buttons
	///////////////////////////////////////////////////////////

	onRefresh() {
		this.loadScanStation();
	}

	onUpdate() {
		this.errorMessage = "";

		this.SelectedScanStations = this.SelectedScanStations.filter((ss) => ss.AlreadyRebuilding == false);

		if (this.SelectedScanStations.length == 0) {
			this.errorMessage = "Select ScanStations to Rebuild. If a rebuild was already requested it will do a rebuild the next time it starts up.";
			return;
		}

		var Msg =
			"You are about to update " +
			this.SelectedScanStations.length +
			" ScanStations. This can take a while and slow down larger servers. Are you sure you want to continue?";

		this.confirmationService.confirm({
			key: "ssrebuildconfirm",
			acceptLabel: "Yes",
			rejectVisible: true,
			rejectLabel: "No",
			message: Msg,
			header: "Confirm Rebuild",
			icon: "fa",
			accept: () => {
				this.onDoubleCheckUpdate();
			},
		});
	}

	onDoubleCheckUpdate() {
		var Msg =
			"Make sure you close ScanStation then restart the program to rebuild the DB. " +
			"NOTE: If you want to do rebuilds overnight make sure you CLOSE then START the program at the end of the day. " +
			"If the program isn't turned on until the next morning it can slow down the server and you won't be able to use the stations until they finish rebuilding. " +
			"Do you want to continue?";

		this.confirmationService.confirm({
			key: "ssrebuilddoublecheck",
			acceptLabel: "Yes",
			rejectVisible: true,
			rejectLabel: "No",
			message: Msg,
			header: "Confirm Rebuild",
			icon: "fa",
			accept: () => {
				this.onFinishUpdate();
			},
		});
	}

	onFinishUpdate() {
		this.Processing = true;

		// Create Parms
		var lstSS: number[] = this.SelectedScanStations.map((ScanStation: any) => ScanStation.ScanStationID);

		var parms: IntListRequest = {
			lstIDs: lstSS,
		};

		// Call WS
		var result = this.dataService.ScanStationRebuildMultiple(parms);
		result.subscribe(
			(response: any) => {
				this.Processing = false;

				if (response.Success == true) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "ssrebuild",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Rebuild was requested for " + this.SelectedScanStations.length + " ScanStations.",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.loadScanStation();
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "ssrebuild",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not request a rebuild: " + response.ErrorMessage,
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {
				this.Processing = false;
			}
		);
	}

	///////////////////////////////////////////////////////////

	///////////////////////////////////////////////////////////
	// Events
	///////////////////////////////////////////////////////////

	onSchoolChange(val) {
		this.SelectedSchool = val;

		this.loadFacility();
	}

	onFacilityChange(val) {
		this.SelectedFacility = val;

		this.loadScanStation();
	}

	onRowSelect(val) {
		this.errorMessage = "";
	}
	onRowUnselect(val) {
		this.errorMessage = "";
	}

	///////////////////////////////////////////////////////////

	///////////////////////////////////////////////////////////
	// Helpers
	///////////////////////////////////////////////////////////

	IsLoading() {
		return this.Processing == true || this.LoadingFacility == true || this.LoadingScanStation == true;
	}

	///////////////////////////////////////////////////////////
}
